export default __webpack_public_path__ + "static/media/Jangyasaeni Pradhan.b24718f5.png";